import { ChevronRight } from "lucide-react";

interface Props {
  title: string;
  actionLabel?: string;
  onAction?: () => void;
}

/** Section header with an optional right-aligned action ("Показать все"). */
export function SectionHeaderAction({ title, actionLabel = "все", onAction }: Props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "18px 16px 8px",
      }}
    >
      <span
        style={{
          fontFamily: "var(--font-body)",
          fontSize: 13,
          color: "var(--fg-section-header)",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          fontWeight: 500,
        }}
      >
        {title}
      </span>
      {onAction && (
        <button
          type="button"
          onClick={onAction}
          style={{
            background: "transparent",
            border: 0,
            cursor: "pointer",
            color: "var(--brand-orange)",
            display: "inline-flex",
            alignItems: "center",
            gap: 2,
            fontFamily: "var(--font-body)",
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {actionLabel} <ChevronRight size={14} />
        </button>
      )}
    </div>
  );
}
